(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["multicolor-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /* ── Helpers ─────────────────────────────────────────────────── */

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.money_format) || 'Rs. {{amount}}';
    var amount  = (cents / 100).toFixed(0);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace(/\{\{.*?\}\}/g, amount);
  }

  /* ── Dispatch the theme's CartAddEvent so cart drawer opens ──── */
  function dispatchCartAdd(cart) {
    /*
      The theme's CartDrawerComponent listens for 'cart:update'
      (ThemeEvents.cartUpdate = CartAddEvent.eventName) with hasAttribute('auto-open').
      We replicate what product-form.js does.
    */
    var evt = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        data: { source: 'multicolor-picker' }
      }
    });
    document.dispatchEvent(evt);

    /* Also fire legacy cart:open used by some themes / custom code */
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* ── Per-picker initialisation ──────────────────────────────── */
  function initPicker(picker) {
    if (picker.dataset.mcInit) return;
    picker.dataset.mcInit = '1';

    var productId   = picker.dataset.productId;
    var minColors   = parseInt(picker.dataset.min, 10) || 1;
    var maxColors   = parseInt(picker.dataset.max, 10) || 6;
    var colorIndex  = parseInt(picker.dataset.colorIndex, 10) || 0;

    /* Load variant JSON */
    var variantsData = [];
    var jsonEl = document.getElementById('mc-variants-' + productId);
    if (jsonEl) {
      try { variantsData = JSON.parse(jsonEl.textContent); } catch (e) {}
    }

    /* Derive non-color option count */
    var colorCheckboxes   = Array.from(picker.querySelectorAll('.mc-color-input'));
    var nonColorFieldsets = Array.from(picker.querySelectorAll('.mc-non-color-option'));

    /* Track selected non-color options as an object { optionIndex: value } */
    var selectedNonColor = {};
    nonColorFieldsets.forEach(function (fs) {
      var idx      = parseInt(fs.dataset.mcOptionIndex, 10);
      var checked  = fs.querySelector('input[type=radio]:checked');
      selectedNonColor[idx] = checked ? checked.value : null;
    });

    var summaryEl    = picker.querySelector('.mc-summary');
    var summaryColors = picker.querySelector('.mc-summary__colors');
    var summaryTotal  = picker.querySelector('.mc-summary__total');
    var messageEl    = picker.querySelector('.mc-message');
    var addBtn       = picker.querySelector('.mc-add-btn');
    var btnText      = picker.querySelector('.mc-add-btn__text');
    var btnIcon      = picker.querySelector('.mc-add-btn__icon');
    var btnLoading   = picker.querySelector('.mc-add-btn__loading');
    var btnAdded     = picker.querySelector('.mc-add-btn__added');
    var countNumEl   = picker.querySelector('.mc-color-count-num');

    /* ── Resolve variant for given colorVariantId + non-color selections ── */
    function resolveVariant(colorVariantId) {
      /*
        If there are no non-color options, the colorVariantId IS the variant to add.
        If there are non-color options (e.g. Size), find the variant that matches
        both the color AND all other selected options.
      */
      if (nonColorFieldsets.length === 0) {
        return colorVariantId;
      }

      /* Build the options array in the product's option order */
      var targetOptions = [];
      var totalOptions  = nonColorFieldsets.length + 1; /* +1 for color */

      /* Find the color name from its checkbox */
      var colorCb   = colorCheckboxes.find(function (cb) { return parseInt(cb.value, 10) === colorVariantId; });
      var colorName = colorCb ? colorCb.dataset.color : null;

      /* We know the colorIndex and non-color indices */
      for (var i = 0; i < totalOptions; i++) {
        if (i === colorIndex) {
          targetOptions.push(colorName);
        } else {
          targetOptions.push(selectedNonColor[i] || null);
        }
      }

      var found = variantsData.find(function (v) {
        return v.options.every(function (o, i) {
          return targetOptions[i] === null || o === targetOptions[i];
        });
      });

      return found ? found.id : colorVariantId;
    }

    /* ── Get checked colors ── */
    function getChecked() {
      return colorCheckboxes.filter(function (cb) { return cb.checked && !cb.disabled; });
    }

    /* ── Render count and summary ── */
    function update() {
      var checked = getChecked();
      var count   = checked.length;

      /* Update count label */
      if (countNumEl) countNumEl.textContent = count;

      /* Summary */
      if (count > 0) {
        summaryEl.hidden = false;
        var names = checked.map(function (cb) { return cb.dataset.color; }).join(', ');
        var total = checked.reduce(function (s, cb) { return s + parseInt(cb.dataset.price, 10); }, 0);
        summaryColors.textContent = names;
        summaryTotal.textContent  = '(' + formatMoney(total) + ')';
      } else {
        summaryEl.hidden = true;
      }

      /* Button */
      addBtn.disabled = count < minColors;
      if (count >= minColors) {
        btnText.textContent = count === 1 ? 'Add to Cart' : ('Add ' + count + ' Colors to Cart');
        btnIcon.hidden = false;
      } else {
        btnText.textContent = 'Add to Cart';
        btnIcon.hidden = true;
      }

      /* Hide stale message on any interaction */
      messageEl.hidden = true;
    }

    /* ══════════════════════════════════════════════════════════════
       Gallery image switching

       product-media.liquid wraps every media as:
         <div class="product-media" data-media-id="{{ media.id }}">

       The slideshow's .select(index) uses its internal
       `.slides` getter (which filters out hidden slides).
       So we must compute the index among VISIBLE slides only.

       We also build a colour→mediaId map from the variant JSON
       as a fallback in case the Liquid data-media-id is empty
       (happens when variant has no attached featured image).
    ═══════════════════════════════════════════════════════════════ */

    /* Build a map: colorName → mediaId from variant data */
    var colorMediaMap = {};
    variantsData.forEach(function (v) {
      if (!v.featured_media_id) return;
      var colorName = v.options[colorIndex];
      if (colorName && !colorMediaMap[colorName]) {
        colorMediaMap[colorName] = String(v.featured_media_id);
      }
    });

    function getMediaIdForLabel(label, cb) {
      /* First try the data attribute set by Liquid */
      var id = label.dataset.mediaId || (cb && cb.dataset.mediaId);
      if (id) return id;
      /* Fallback: lookup from variant JSON by color name */
      var colorName = label.dataset.color || (cb && cb.dataset.color);
      return colorMediaMap[colorName] || null;
    }

    function getSlideshow() {
      /* media-gallery > slideshow-component is the product gallery */
      var gallery = document.querySelector('media-gallery');
      if (gallery) {
        return gallery.querySelector('slideshow-component');
      }
      /* Fallback: any slideshow-component in the section */
      var section = picker.closest('.shopify-section');
      return section
        ? section.querySelector('slideshow-component')
        : document.querySelector('slideshow-component');
    }

    function showMediaForColor(mediaId) {
      if (!mediaId) return;
      var slideshow = getSlideshow();
      if (!slideshow) return;

      /* Wait for the custom element to be defined & initialised */
      if (typeof slideshow.select !== 'function') {
        customElements.whenDefined('slideshow-component').then(function () {
          showMediaForColor(mediaId);
        });
        return;
      }

      /*
        slideshow.refs.slides = ALL slideshow-slide elements
        slideshow.slides      = only visible (non-hidden) ones
        slideshow.select(n)   indexes into .slides (filtered)

        We need the index among .slides, not among .refs.slides.
      */
      var allSlides = slideshow.refs && slideshow.refs.slides
        ? slideshow.refs.slides
        : Array.from(slideshow.querySelectorAll('slideshow-slide'));

      /* Find the slide DOM element that contains this media */
      var targetSlide = null;
      var id = String(mediaId);
      for (var i = 0; i < allSlides.length; i++) {
        if (allSlides[i].querySelector('[data-media-id="' + id + '"]')) {
          targetSlide = allSlides[i];
          break;
        }
      }
      if (!targetSlide) return;

      /* Get its index among the filtered (visible) slides */
      var visibleSlides = slideshow.slides || allSlides;
      var visibleIndex = visibleSlides.indexOf(targetSlide);

      /* If the slide is hidden, reveal it then re-index */
      if (visibleIndex === -1 && targetSlide.hasAttribute('hidden')) {
        targetSlide.setAttribute('reveal', '');
        targetSlide.setAttribute('aria-hidden', 'false');
        visibleSlides = slideshow.slides || allSlides;
        visibleIndex = visibleSlides.indexOf(targetSlide);
      }

      if (visibleIndex !== -1) {
        slideshow.select(visibleIndex, undefined, { animate: true });
      }
    }

    /* On hover: preview the hovered color's image */
    var lastCheckedMediaId = null;

    colorCheckboxes.forEach(function (cb) {
      var label = cb.closest('.mc-swatch-label');
      if (!label) return;

      label.addEventListener('mouseenter', function () {
        var mediaId = getMediaIdForLabel(label, cb);
        if (mediaId) showMediaForColor(mediaId);
      });

      label.addEventListener('mouseleave', function () {
        /* On leave, revert to the most recently checked color's image */
        if (lastCheckedMediaId) {
          showMediaForColor(lastCheckedMediaId);
        }
      });
    });

    /* ── Enforce max selection ── */
    var checkedOrder = 0;
    colorCheckboxes.forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (this.checked) {
          checkedOrder++;
          this.dataset.order = checkedOrder;
          /* If over max, uncheck the earliest */
          var checked = getChecked();
          if (checked.length > maxColors) {
            var sorted = checked.slice().sort(function (a, b) {
              return parseInt(a.dataset.order || 0, 10) - parseInt(b.dataset.order || 0, 10);
            });
            sorted[0].checked = false;
          }
          /* Switch gallery to this color's image */
          var label = this.closest('.mc-swatch-label');
          var mediaId = getMediaIdForLabel(label, this);
          if (mediaId) {
            lastCheckedMediaId = mediaId;
            showMediaForColor(mediaId);
          }
        } else {
          this.dataset.order = 0;
          /* After unchecking, show the most recently still-checked color */
          var stillChecked = getChecked();
          if (stillChecked.length > 0) {
            var lastCb = stillChecked[stillChecked.length - 1];
            var lastLabel = lastCb.closest('.mc-swatch-label');
            lastCheckedMediaId = getMediaIdForLabel(lastLabel, lastCb);
            if (lastCheckedMediaId) showMediaForColor(lastCheckedMediaId);
          } else {
            lastCheckedMediaId = null;
          }
        }
        update();
      });
    });

    /* ── Non-color option changes ── */
    nonColorFieldsets.forEach(function (fs) {
      var idx = parseInt(fs.dataset.mcOptionIndex, 10);
      /* Update selected label text */
      var legendSpan = fs.querySelector('.mc-selected-non-color-label');
      fs.addEventListener('change', function (e) {
        if (e.target.type === 'radio') {
          selectedNonColor[idx] = e.target.value;
          if (legendSpan) legendSpan.textContent = e.target.value;

          /* Re-resolve variant IDs for each colour checkbox based on new size */
          colorCheckboxes.forEach(function (cb) {
            var resolvedId = resolveVariant(parseInt(cb.dataset.variantId, 10));
            cb.value = resolvedId;

            /* Update price display from variantsData */
            var vData = variantsData.find(function (v) { return v.id === resolvedId; });
            if (vData) {
              cb.dataset.price = vData.price;
              /* Disable if unavailable */
              if (!vData.available) {
                cb.disabled = true;
                cb.checked  = false;
                var lbl = cb.closest('.mc-swatch-label');
                if (lbl) lbl.dataset.available = 'false';
              } else {
                cb.disabled = false;
                var lbl = cb.closest('.mc-swatch-label');
                if (lbl) lbl.dataset.available = 'true';
              }
            }
          });

          update();
        }
      });
      /* Initialise label to first selected value */
      var firstChecked = fs.querySelector('input:checked');
      if (legendSpan && firstChecked) legendSpan.textContent = firstChecked.value;
    });

    /* ── Add to cart ── */
    addBtn.addEventListener('click', function () {
      var checked = getChecked();
      if (checked.length < minColors) {
        showMessage('Please select at least ' + minColors + ' color' + (minColors > 1 ? 's' : '') + '.', 'error');
        return;
      }

      /* Build items: for each checked colour, resolve the correct variant */
      var items = checked.map(function (cb) {
        var baseId    = parseInt(cb.dataset.variantId, 10);
        var resolved  = resolveVariant(baseId);
        return { id: resolved, quantity: 1 };
      });

      setLoading(true);
      messageEl.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart.'); });
          return r.json();
        })
        .then(function () {
          /* Fetch the updated cart to pass to CartAddEvent detail */
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          setAdded(checked.length);
          updateCartBubbles(cart.item_count);
          dispatchCartAdd(cart);

          /* Reset after 2.5s */
          setTimeout(function () {
            resetButton();
            colorCheckboxes.forEach(function (cb) { cb.checked = false; cb.dataset.order = 0; });
            update();
          }, 2500);
        })
        .catch(function (err) {
          setLoading(false);
          showMessage(err.message || 'Something went wrong. Please try again.', 'error');
        });
    });

    /* ── UI state helpers ── */
    function setLoading(on) {
      addBtn.disabled    = on;
      btnText.hidden     = on;
      btnIcon.hidden     = true;
      btnLoading.hidden  = !on;
      btnAdded.hidden    = true;
    }

    function setAdded(count) {
      addBtn.disabled    = false;
      btnText.hidden     = true;
      btnIcon.hidden     = true;
      btnLoading.hidden  = true;
      btnAdded.hidden    = false;
      showMessage(count + ' color' + (count > 1 ? 's' : '') + ' added to your cart!', 'success');
    }

    function resetButton() {
      addBtn.disabled    = true;
      btnText.hidden     = false;
      btnIcon.hidden     = true;
      btnLoading.hidden  = true;
      btnAdded.hidden    = true;
      btnText.textContent = 'Add to Cart';
      messageEl.hidden    = true;
    }

    function showMessage(text, type) {
      messageEl.textContent   = text;
      messageEl.dataset.type  = type;
      messageEl.hidden        = false;
    }

    function updateCartBubbles(count) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-bubble__count, [data-testid="cart-count"]').forEach(function (el) {
        if (el.tagName === 'SPAN' || el.tagName === 'DIV' || el.tagName === 'P') {
          el.textContent = count;
        }
        el.hidden = count === 0;
      });
    }

    /* ── Initial render ── */
    update();
  }

  /* ── Boot ── */
  function boot() {
    document.querySelectorAll('.multicolor-picker:not([data-mc-init])').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
